import { render, staticRenderFns } from "./SealPlate3.vue?vue&type=template&id=449bc21b&scoped=true"
import script from "./SealPlate3.vue?vue&type=script&lang=js"
export * from "./SealPlate3.vue?vue&type=script&lang=js"
import style0 from "./SealPlate3.vue?vue&type=style&index=0&id=449bc21b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bc21b",
  null
  
)

export default component.exports